import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AllDeliveryDetailsDto } from 'src/app/Model/Shipping/all-delivery-details-dto';
import { Constant } from 'src/app/Common/constant';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { DeliveryFeedBack } from 'src/app/Model/Shipping/delivery-feed-back';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';

@Component({
  selector: 'shipping-rating',
  templateUrl: './shipping-rating.component.html',
  styleUrls: ['./shipping-rating.component.css']
})
export class ShippingRatingComponent implements OnInit, OnDestroy {

  employeeCode: string;
  pickedUpShippingData: AllDeliveryDetailsDto = new AllDeliveryDetailsDto();
  ratingLocationType: number = 0;
  ratingCustomerType: number = 0;
  ratingData: DeliveryFeedBack[] = [];
  isShowSubmit: boolean = false;
  constant: Constant = new Constant();
  errorLog: ErrorLog = new ErrorLog();

  //Subscription
  private insertFeedBackSubscription: Subscription;
  private getFeedBackSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dialogRef: MatDialogRef<ShippingRatingComponent>,
    public dialog: MatDialog,
    private toastService: ToastrService,
    private apiFactory: APIFactoryEndPoints,
    public persistenceService: LocalStorageService,
    private shippingManagerService: ShippingManagerService,
  ) {
    // dialogRef.disableClose = true;
    this.employeeCode = JSON.parse(this.persistenceService.get("google_email"));
    // this.employeeCode = '0001-112';
    this.pickedUpShippingData = dialogData.shippingData;
    console.log(this.pickedUpShippingData)
  }

  ngOnInit(): void {
    this.getFeedBack();
  }

  ngOnDestroy() {
    if (this.insertFeedBackSubscription !== undefined)
      this.insertFeedBackSubscription.unsubscribe();

    if (this.getFeedBackSubscription !== undefined)
      this.getFeedBackSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  getFeedBack() {
    this.getFeedBackSubscription = this.shippingManagerService.getFeedBack(this.apiFactory.getShippingFeedBack, this.pickedUpShippingData.assignedDeliveryDto?.assignedNo)
      .subscribe((data: DeliveryFeedBack[]) => {
        this.ratingData = data;
        if (data.length > 0) {
          data.forEach(element => {
            if (element.feedbackFor == 'Customer') {
              this.ratingCustomerType = element.toCustomer;
            } else if (element.feedbackFor == 'Location') {
              this.ratingLocationType = element.toLocation;
            }
          })
          this.isShowSubmit = false;
        }
      },
        (error: HttpErrorResponse) => {
          this.insertErrorLog("getFeedBack", error);
        });
  }

  ratingClick() {
    if (this.ratingData.length == 0) {
      if (this.ratingLocationType > 0 && this.ratingCustomerType > 0) {
        this.isShowSubmit = true;
      }
      else {
        this.isShowSubmit = false;
      }
    }
  }


  saveClick() {
    let rating: DeliveryFeedBack[] = [];
    console.log(this.pickedUpShippingData)

    if (this.ratingLocationType > 0) {
      let locationRating: DeliveryFeedBack = new DeliveryFeedBack();
      locationRating.assignedNo = this.pickedUpShippingData.assignedDeliveryDto?.assignedNo;
      locationRating.feedbackBy = this.employeeCode;
      locationRating.feedbackDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      locationRating.feedbackFor = "Location";
      locationRating.locationCode = this.pickedUpShippingData.locationCode;
      locationRating.servicemanCode = Number(this.pickedUpShippingData.assignedDeliveryDto?.serviceManCode);
      locationRating.toLocation = this.ratingLocationType;

      rating.push(locationRating);
    }
    if (this.ratingCustomerType > 0) {
      let customerRating: DeliveryFeedBack = new DeliveryFeedBack();
      customerRating.assignedNo = this.pickedUpShippingData.assignedDeliveryDto?.assignedNo;
      customerRating.feedbackBy = this.employeeCode;
      customerRating.customerCode = this.pickedUpShippingData.customerDeliveryDetails?.refNo;
      customerRating.feedbackDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      customerRating.feedbackFor = "Customer";
      customerRating.locationCode = this.pickedUpShippingData.locationCode;
      customerRating.servicemanCode = Number(this.pickedUpShippingData.assignedDeliveryDto?.serviceManCode);
      customerRating.toCustomer = this.ratingCustomerType;

      rating.push(customerRating);
    }
    console.log(rating)

    if (this.ratingLocationType > 0 && this.ratingCustomerType > 0) {
      this.insertFeedBackSubscription = this.shippingManagerService.insertFeedBack(this.apiFactory.insertShippingFeedBack, rating)
        .subscribe((data: any) => {
          if (data) {
            this.toastService.showSuccessToast(this.constant.feedbackToast);
            this.dialogRef.close(data);
          }
        },
          (error: HttpErrorResponse) => {
            this.insertErrorLog("saveClick", error);
          });
    }
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Shipping Manager";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message|| error?.error?.message!= '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiFactory.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }

}
